import React, { useState } from "react";
import "../styles/chatbot.css";

const API_BASE_URL = process.env.REACT_APP_FASTAPI_URL;

const CampaignChatBot = () => {
  const [messages, setMessages] = useState([
    { sender: "bot", text: "Hi! Ask me anything about your campaign." }
  ]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSend = async () => {
    if (!input.trim() || loading) return;
    setLoading(true);
    const userMessage = { sender: "user", text: input };
    setMessages(prev => [...prev, userMessage]);
    try {
      const res = await fetch(`${API_BASE_URL}/reports/chatbot`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ query: input })
      });
      const data = await res.json();
      const botMessage = { sender: "bot", text: data.response };
      setMessages(prev => [...prev, botMessage]);
    } catch {
      setMessages(prev => [...prev, { sender: "bot", text: "Sorry, something went wrong." }]);
    }
    setInput("");
    setLoading(false);
  };

  // Trigger send on Enter key (provides Shift+Enter for multi-line)
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <div className="chatbot-container" style={{height:'78vh'}}>
    
      <div className="chat-window">
        {messages.map((msg, i) => (
          <div key={i} className={`message ${msg.sender}`}>
            <div dangerouslySetInnerHTML={{ __html: msg.text }} />
          </div>
        ))}
        {loading && (
          <div className="loader">
            <div className="spinner"></div>
            <span>Loading...</span>
          </div>
        )}
      </div>
      <div className="input-bar">
        <textarea
          value={input}
          onChange={e => setInput(e.target.value)}
          placeholder="Type your question..."
          rows={4}
          style={{ resize: "vertical", width: "100%", padding: "0.5rem" }}
          onKeyDown={handleKeyDown}
          disabled={loading}
        />
        <button onClick={handleSend} disabled={loading}>Send</button>
      </div>
    </div>
  );
};

export default CampaignChatBot;
